import { createElementBlock as l, openBlock as n, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(a, e) {
  return n(), l("svg", t, e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.222 4C2.397 4 1 5.539 1 7.333v2.334a1 1 0 0 0 1 1h20q.103 0 .201-.02a1 1 0 0 0 .799-.98V7.333C23 5.54 21.603 4 19.778 4h-2.323a1 1 0 1 0 0 2h2.323C20.408 6 21 6.55 21 7.333v1.334H3V7.333C3 6.55 3.593 6 4.222 6h9.596a1 1 0 1 0 0-2zM3 13.59a1 1 0 1 0-2 0v3.077C1 18.46 2.397 20 4.222 20h15.556C21.603 20 23 18.461 23 16.667V13.59a1 1 0 1 0-2 0v3.076C21 17.45 20.407 18 19.778 18H4.222C3.592 18 3 17.45 3 16.667zM6 15a1 1 0 1 0 0 2h4.182a1 1 0 1 0 0-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c = { render: r };
export {
  c as default,
  r as render
};
//# sourceMappingURL=ic_payment-CuGQbted.js.map
